import { render, staticRenderFns } from "./mobilFooter.vue?vue&type=template&id=76af941a&scoped=true&"
import script from "./mobilFooter.vue?vue&type=script&lang=js&"
export * from "./mobilFooter.vue?vue&type=script&lang=js&"
import style0 from "./mobilFooter.vue?vue&type=style&index=0&id=76af941a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af941a",
  null
  
)

export default component.exports